/* CRC Infinite Scroll — CHECK SENTINEL POSITION */
(function () {
  const S = (window.__crcInfColl || (window.__crcInfColl = {
    observer: null,
    seen: new Set(),
    keyspace: '',
    loading: false,
    requireUserScroll: false,
    ignoreNextMutation: false
  }));

  const log = (...a) => console.log('[CRC∞]', ...a);

  function findGrid(root = document) {
    return (root || document).querySelector('[data-crc-grid]') || (root || document).querySelector('#product-grid');
  }
  function findSentinel(root = document) {
    return (root || document).querySelector('#crc-infinite-sentinel');
  }

  function canonicalKey(path) {
    try {
      path = (path || '').toLowerCase();
      if (path.endsWith('/')) path = path.slice(0, -1);
      const m = path.match(/^\/products\/[^\/]+/);
      return m ? m[0] : null;
    } catch { return null; }
  }
  
  function cardKey(li) {
    const a = li?.querySelector('a[href*="/products/"]');
    if (!a) return null;
    return canonicalKey(new URL(a.getAttribute('href'), location.origin).pathname);
  }
  
  function seedSeen(grid) {
    S.seen.clear();
    Array.from(grid.children).forEach(li => {
      const k = cardKey(li);
      if (k) S.seen.add(k);
    });
    log('Seeded', S.seen.size);
  }

  function keyspace() {
    const u = new URL(location.href);
    u.searchParams.delete('page');
    return u.pathname + '?' + u.searchParams.toString();
  }

  // Check if sentinel is near viewport
  function isSentinelNearViewport(sentinel) {
    const rect = sentinel.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const distanceFromBottom = rect.top - viewportHeight;
    // Within 2000px of viewport bottom
    return distanceFromBottom < 2000;
  }

  async function fetchNext(url) {
    try {
      const res = await fetch(url, { 
        headers: { 'X-Requested-With': 'XMLHttpRequest' }, 
        credentials: 'same-origin' 
      });
      
      if (!res.ok) throw new Error('HTTP ' + res.status);
      
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = findGrid(doc);
      
      if (!newGrid) return { items: [], nextUrl: '' };
      
      const items = [];
      Array.from(newGrid.children).forEach(li => {
        const k = cardKey(li);
        if (k && !S.seen.has(k)) {
          S.seen.add(k);
          items.push(li);
        }
      });

      const newSentinel = doc.querySelector('#crc-infinite-sentinel');
      const nextUrl = newSentinel?.getAttribute('data-next-url') || '';

      return { 
        items, 
        nextUrl: nextUrl ? new URL(nextUrl, location.origin).toString() : '' 
      };
    } catch (e) {
      log('Error:', e);
      return { items: [], nextUrl: '' };
    }
  }

  function armObserver() {
    const grid = findGrid();
    const sentinel = findSentinel();
    
    if (!grid || !sentinel) return;
    if (!sentinel.getAttribute('data-next-url')) return;

    if (S.observer) {
      try { S.observer.disconnect(); } catch (_) {}
    }

    S.observer = new IntersectionObserver((entries) => {
      if (S.requireUserScroll) return;
      if (entries[0].isIntersecting) {
        log('Sentinel visible!');
        loadNext();
      }
    }, { rootMargin: '1600px' });

    S.observer.observe(sentinel);
  }

  async function loadNext() {
    const grid = findGrid();
    const sentinel = findSentinel();
    
    if (!grid || !sentinel) return;

    const nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl || S.loading) return;
    
    S.loading = true;

    try {
      log('Loading:', nextUrl);
      const { items, nextUrl: newNext } = await fetchNext(nextUrl);

      if (items.length) {
        S.ignoreNextMutation = true;
        
        const frag = document.createDocumentFragment();
        items.forEach(item => frag.appendChild(item));
        grid.appendChild(frag);
        log('Added', items.length, '→', grid.children.length);
        
        setTimeout(() => { S.ignoreNextMutation = false; }, 500);
      }

      if (!newNext || !items.length) {
        sentinel.removeAttribute('data-next-url');
        if (S.observer) S.observer.disconnect();
        log('End');
        return;
      }

      sentinel.setAttribute('data-next-url', newNext);
      
      if (S.observer) {
        S.observer.observe(sentinel);
      }
      
      // Check if sentinel is near viewport (within 2000px)
      const sentinelNear = isSentinelNearViewport(sentinel);
      log('Sentinel near viewport?', sentinelNear);
      
      if (sentinelNear) {
        // Keep loading
        log('Continuing...');
        setTimeout(loadNext, 100);
      } else {
        log('Sentinel far away, waiting for scroll');
      }

    } catch (e) {
      log('Error:', e);
    } finally {
      S.loading = false;
    }
  }

  function boot(why) {
    log('Boot:', why);
    
    const grid = findGrid();
    const sentinel = findSentinel();
    
    if (!grid || !sentinel) return;

    const ks = keyspace();
    if (S.keyspace !== ks) {
      log('Keyspace changed');
      S.keyspace = ks;
      seedSeen(grid);
      S.requireUserScroll = (why === 'filter');
    }

    if (S.requireUserScroll) {
      log('Waiting for scroll...');
      const unlock = () => {
        S.requireUserScroll = false;
        log('Unlocked!');
        loadNext();
      };
      window.addEventListener('scroll', unlock, { passive: true, once: true });
      window.addEventListener('touchmove', unlock, { passive: true, once: true });
    }

    armObserver();
    
    if (why === 'init') {
      loadNext();
    }
  }

  function watchForGridReplacement() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    
    const observer = new MutationObserver(() => {
      if (S.ignoreNextMutation) {
        log('Ignoring self-mutation');
        return;
      }
      
      log('Filter applied!');
      setTimeout(() => boot('filter'), 100);
    });
    
    observer.observe(container, { childList: true, subtree: true });
    log('Watching for filters');
  }

  const init = () => {
    const grid = findGrid();
    const sentinel = findSentinel();
    if (grid && sentinel) {
      boot('init');
      watchForGridReplacement();
    } else {
      setTimeout(init, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  log('Loaded');
})();